import * as React from 'react'

import { CompanyIdentifierRow } from './CompanyIdentifierRow'
import { useCompanyIdentifier } from './hooks/useCompanyIdentifier'
import { CompanyIdentifierVariant } from './typings'

interface Props {
  variant: CompanyIdentifierVariant
}

/**
 * The tenant's company identifier (icon plus name/address text) for page
 * headers. Renders nothing when there is nothing to show. The measuring hook
 * lives in the row so it is only called once an identifier exists.
 */
export function CompanyIdentifier(props: Props) {
  const identifier = useCompanyIdentifier()
  if (!identifier) return null

  return (
    <CompanyIdentifierRow identifier={identifier} variant={props.variant} />
  )
}

CompanyIdentifier.displayName = 'CompanyIdentifier'
